require('./angular-sanitize');
module.exports = 'ngSanitize';



//////////////////
// WEBPACK FOOTER
// /Users/shakyshane/Sites/oss/UI/~/angular-sanitize/index.js
// module id = 6
// module chunks = 0